import { useEffect, useState } from 'react';

// https://firestore.googleapis.com/v1beta1/projects/singhpratyush-in/databases/(default)/documents/social-links

export const useAllFromCollection = (collectionName, defaultDocs = []) => {
	const [docs, setDocs] = useState(defaultDocs);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(
		() => {
			fetch(`https://firestore.googleapis.com/v1beta1/projects/singhpratyush-in/databases/(default)/documents/${collectionName}`)
				.then(response => response.json())
				.then(json => {
					setDocs(json.documents);
					setIsLoading(false);
				});

		},
		[true],
	);

	return [isLoading, docs];
};



// WEBPACK FOOTER //
// ./src/firebase/hooks.js